import React from "react";
import { Grid, List } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { SettingListKeys } from "../../helpers/constants";
import { useAppDispatch, useAppSelector } from "../app/appHooks";
import { SettingsListItem } from "./common/SettingsListItem";
import { setEntraConfigOpt } from "./settingsSlice";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    settingsContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "260px",
      background: theme.palette.light.main,
      borderRight: "1px solid rgba(0, 0, 0, 0.12)",
      padding: theme.spacing(3, 0, 0, 0),
    },
    listContainer: {
      background: "#FFF",
    },
    disabledListContainer: {
      background: "#FFF",
      color: theme.palette.text.disabled,
    },
    optionsContainer: {
      width: "100%",
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(3),
    },
    itemLabelContainer: {
      display: "flex",
      width: "100%",
      alignItems: "center",
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
    },
    secondaryTextContainer: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      paddingLeft: theme.spacing(2),
    },
  })
);

export function MicrosoftEntraSettingsList() {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const selectedOption = useAppSelector(
    (state) => state.settingsState.selectedOption
  );
  const selectedEntraConfigOpt = useAppSelector(
    (state) => state.settingsState.selectedEntraConfigOpt
  );
  const selectedOrganizationID = useAppSelector(
    (state) => state.headerState.selectedOrganization
  );
  const hasSSOConfiguration = useAppSelector(
    (state) => !!state.settingsState.organizationSettings?.sso_config
  );

  if (
    selectedOption !== SettingListKeys.microsoft_entra ||
    selectedOrganizationID === undefined
  )
    return null;

  return (
    <div className={classes.settingsContainer}>
      <List className={classes.optionsContainer}>
        <SettingsListItem
          button
          divider
          disableGutters
          onClick={() =>
            dispatch(setEntraConfigOpt(SettingListKeys.entra_sso_configuration))
          }
          selected={
            selectedEntraConfigOpt === SettingListKeys.entra_sso_configuration
          }
          className={classes.listContainer}
        >
          <Grid container className={classes.itemLabelContainer}>
            <Grid item xs={12}>
              <div className={classes.secondaryTextContainer}>
                {t("sso_configuration")}
              </div>
            </Grid>
          </Grid>
        </SettingsListItem>
        <SettingsListItem
          button
          divider
          disabled={!hasSSOConfiguration}
          disableGutters
          onClick={() =>
            hasSSOConfiguration &&
            dispatch(setEntraConfigOpt(SettingListKeys.entra_group_mapping))
          }
          selected={
            selectedEntraConfigOpt === SettingListKeys.entra_group_mapping
          }
          className={
            hasSSOConfiguration
              ? classes.listContainer
              : classes.disabledListContainer
          }
        >
          <Grid container className={classes.itemLabelContainer}>
            <Grid item xs={12}>
              <div className={classes.secondaryTextContainer}>
                {t("group_mapping")}
              </div>
            </Grid>
          </Grid>
        </SettingsListItem>
      </List>
    </div>
  );
}
